/**
 * 消息卡片组件
 * @author ritaxxu
 */
import React, { useState } from 'react'
import { Tag, Button } from 'antd'
import { AlertOutlined, CheckCircleOutlined } from '@ant-design/icons'
import {
  IInnerMsgItem,
  InnerMsgLevel,
  InnerMsgReadStatus,
} from '@types'

interface MessageCardProps {
  message: IInnerMsgItem
  onClick: () => void
  onMarkAsRead: () => void
}

const MessageCard: React.FC<MessageCardProps> = ({ message, onClick, onMarkAsRead }) => {
  const [hovered, setHovered] = useState(false)

  const isUnread = message.readStatus === InnerMsgReadStatus.Unread
  const isImportant = message.level === InnerMsgLevel.Important
  // 设计稿每条消息只展示一个业务分类
  const category = message.tags?.[0]

  const handleMark = (e: React.MouseEvent) => {
    e.stopPropagation()
    onMarkAsRead()
  }

  return (
    <div
      className="notification-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <div className="notification-card-main">
        <div className="notification-card-row">
          {isImportant && (
            <Tag
              icon={<AlertOutlined />}
              className="notification-card-important-tag"
            >
              重要
            </Tag>
          )}
          <span className="notification-card-title">{message.title}</span>
        </div>
        <div className="notification-card-row notification-card-row--meta">
          {category && <span className="notification-card-category">【{category}】</span>}
          <span className="notification-card-time">{message.sentAt}</span>
        </div>
      </div>

      {isUnread && (isImportant || hovered) && (
        <Button
          danger={isImportant}
          size="small"
          icon={<CheckCircleOutlined />}
          className="notification-card-mark-btn"
          onClick={handleMark}
        >
          标为已读
        </Button>
      )}
    </div>
  )
}

export default MessageCard
